/* su-mega-nav.js — Suvene Navigation Drawer */
(function () {
  'use strict';

  const DRAWER_ID = 'su-mega-nav-drawer';
  const OVERLAY_ID = 'su-mega-nav-overlay';

  function init() {
    const drawer = document.getElementById(DRAWER_ID);
    const overlay = document.getElementById(OVERLAY_ID);
    if (!drawer || !overlay) return;

    // ── Open triggers ──
    document.querySelectorAll('[data-su-nav-open]').forEach(btn => {
      btn.addEventListener('click', () => openDrawer(drawer, overlay));
    });

    // ── Close ──
    document.querySelectorAll('[data-su-nav-close]').forEach(btn => {
      btn.addEventListener('click', () => closeDrawer(drawer, overlay));
    });
    overlay.addEventListener('click', () => closeDrawer(drawer, overlay));

    // ── Escape key ──
    document.addEventListener('keydown', e => {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) {
        closeDrawer(drawer, overlay);
      }
    });

    // ── Submenu: hover to open ──
    drawer.querySelectorAll('[data-su-sub-toggle]').forEach(trigger => {
      const target = trigger.dataset.suSubToggle;
      const sub = drawer.querySelector(`[data-su-sub="${target}"]`);
      const wrap = trigger.closest('.su-nav-link-wrap');
      if (!sub || !wrap) return;

      wrap.addEventListener('mouseenter', function () {
        const group = this.closest('.su-nav-group');
        if (group) {
          group.querySelectorAll('.su-nav-sub.is-open').forEach(s => s.classList.remove('is-open'));
          group.querySelectorAll('[data-su-sub-toggle]').forEach(b => b.classList.remove('is-active'));
        }
        // Set display first, then trigger transition on next frame
        sub.style.display = 'flex';
        requestAnimationFrame(() => requestAnimationFrame(() => {
          sub.classList.add('is-open');
        }));
        trigger.classList.add('is-active');
      });

      wrap.addEventListener('mouseleave', function () {
        setTimeout(() => {
          if (!wrap.matches(':hover')) {
            sub.classList.remove('is-open');
            trigger.classList.remove('is-active');
            setTimeout(() => {
              if (!sub.classList.contains('is-open')) sub.style.display = '';
            }, 420);
          }
        }, 80);
      });
    });

    // ── Image panel: hover to switch ──
    const defaultPanel = drawer.querySelector('.su-nav-image-panel.is-default');

    drawer.querySelectorAll('[data-su-image-panel]').forEach(trigger => {
      const panelId = trigger.dataset.suImagePanel;
      const panel = drawer.querySelector(`[data-su-panel="${panelId}"]`);
      if (!panel) return;

      trigger.addEventListener('mouseenter', () => {
        if (defaultPanel) defaultPanel.style.opacity = '0';
        drawer.querySelectorAll('.su-nav-image-panel:not(.is-default)').forEach(p => {
          p.classList.remove('is-visible');
        });
        panel.classList.add('is-visible');
      });

      trigger.addEventListener('mouseleave', () => {
        panel.classList.remove('is-visible');
        setTimeout(() => {
          const anyVisible = drawer.querySelector('.su-nav-image-panel:not(.is-default).is-visible');
          if (!anyVisible && defaultPanel) defaultPanel.style.opacity = '1';
        }, 50);
      });
    });
  }

  function openDrawer(drawer, overlay) {
    drawer.classList.add('is-open');
    overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    // Fix mobile image slider padding via JS (CSS overflow:hidden on parent clips margin)
    fixMobileSlider(drawer);
  }

  function fixMobileSlider(drawer) {
    if (window.innerWidth > 1023) return;
    const slider = drawer.querySelector('.su-nav-mobile-images');
    if (!slider) return;
    slider.style.paddingLeft = '20px';
    slider.style.paddingRight = '20px';
    slider.style.boxSizing = 'content-box';
    slider.style.scrollPaddingLeft = '20px';
  }

  function closeDrawer(drawer, overlay) {
    drawer.classList.remove('is-open');
    overlay.classList.remove('is-open');
    document.body.style.overflow = '';
    drawer.querySelectorAll('.su-nav-sub.is-open').forEach(s => s.classList.remove('is-open'));
    drawer.querySelectorAll('.su-nav-link.is-active').forEach(b => b.classList.remove('is-active'));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();